module.exports = function(data) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }

 var hasIcon = data.header && data.header.title ;
__p += '\n';
 var title = hasIcon ? data.header.title : data.name ;
__p += '\n<div class="filter-menu dropdown-toggle" id="cidAction' +
((__t = (data.cid)) == null ? '' : __t) +
'" data-toggle="dropdown" role="button">\n    ';
 if (!hasIcon) { ;
__p += '\n        ' +
((__t = ( title )) == null ? '' : __t) +
'\n    ';
 } ;
__p += '\n    <a title="' +
((__t = ( title )) == null ? '' : __t) +
'" href="#" data-toggle="tooltip">\n        <i class="fas fa-sort-down" ></i><span class="sr-only">' +
((__t = ( title )) == null ? '' : __t) +
'</span>\n    </a>\n</div>\n<ul id="cidMenu' +
((__t = (data.cid)) == null ? '' : __t) +
'" class="dropdown-menu" role="menu" aria-labelledby="cidAction' +
((__t = (data.cid)) == null ? '' : __t) +
'">\n    <li role="presentation"><span class="sort-filter-label">Show</span></li>\n    ';
 data.filterOptions.forEach(function(elt, i) { ;
__p += '\n    <li role="presentation">\n        <a href="#" data-index="' +
((__t = ( i )) == null ? '' : __t) +
'" data-filter="' +
((__t = ( elt.value )) == null ? '' : __t) +
'" class="filterOption ' +
((__t = ( elt.active ? 'active' : '')) == null ? '' : __t) +
'">\n            <i class="far fa-check check-icon"></i> ' +
((__t = ( elt.name )) == null ? '' : __t) +
'\n        </a>\n    </li>\n    ';
 }); ;
__p += '\n</ul>\n';
return __p
}